/* AMAVYA - navigation et animations (14/09/2026). Aucune bibliotheque, aucun appel reseau.
   Demande de Tarek : navigation la plus fluide possible, animations progressives, et son composant
   GradientMenu (React + react-icons) sur la fiche produit pour changer de photo.
   Le theme Horizon est en Liquid, sans React ni etape de construction : le composant est reecrit ici
   avec les memes degrades, les memes icones (Ionicons 5, celles de react-icons/io5) et les memes durees.
   1. Menu a degrade de la fiche produit.
   2. Navigation instantanee : pages prechargees au survol (Speculation Rules, prefetch seulement).
   3. Cartes produit : arrivee en cascade, inclinaison douce sous le pointeur.
   4. Retour en haut avec anneau de progression ; ombre de l'en-tete au defilement.
   5. Onde au clic sur les boutons.
   6. « t-shirt » ne se coupe plus en fin de ligne. */
(function () {
  'use strict';

  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pointeurFin = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var trait = ' fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"';
  var ICONES = {
    produit: '<path' + trait + ' d="M314.56 48s-22.78 8-58.56 8-58.56-8-58.56-8a31.94 31.94 0 00-10.57 1.8L32 104l16.63 88 48.88 5.52a24 24 0 0121.29 24.58L112 464h288l-6.8-241.9a24 24 0 0121.29-24.58l48.88-5.52L480 104 325.13 49.8a31.94 31.94 0 00-10.57-1.8zM333.31 52.66a80 80 0 01-154.62 0"/>',
    porte: '<path' + trait + ' d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"/><path fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32" d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z"/>',
    photo: '<path' + trait + ' d="M350.54 148.68l-26.62-42.06C318.31 100.08 310.62 96 302 96h-92c-8.62 0-16.31 4.08-21.92 10.62l-26.62 42.06C155.85 155.23 148.62 160 140 160H80a32 32 0 00-32 32v192a32 32 0 0032 32h352a32 32 0 0032-32V192a32 32 0 00-32-32h-59c-8.65 0-16.850-4.77-22.46-11.32z"/><circle cx="256" cy="272" r="80" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/><path' + trait + ' d="M124 158v-22h-24v22"/>',
    livre: '<path' + trait + ' d="M256 160c16-63.16 76.43-95.41 208-96a15.94 15.94 0 0116 16v288a16 16 0 01-16 16c-128 0-177.45 25.81-208 64-30.37-38-80-64-208-64-9.88 0-16-8.05-16-16V80a15.94 15.94 0 0116-16c131.57.59 192 32.84 208 96zM256 160v288"/>',
    dos: '<path' + trait + ' d="M304 48l112 112-112 112M398.87 160H96M208 464L96 352l112-112M114 352h302"/>',
    zoom: '<path' + trait + ' d="M432 320v112H320M421.8 421.77L304 304M80 192V80h112M90.2 90.23L208 208M320 80h112v112M421.77 90.2L304 208M192 432H80V320M90.23 421.8L208 304"/>',
    partager: '<circle cx="128" cy="256" r="48"' + trait + '/><circle cx="384" cy="112" r="48"' + trait + '/><circle cx="384" cy="400" r="48"' + trait + '/><path' + trait + ' d="M169.83 279.53l172.34 96.94M342.17 135.53l-172.34 96.94"/>'
  };

  /* Les degrades du composant fourni : Home, Photo, Video, Tym, puis Share pour le partage. */
  var DEGRADES = [['#a955ff', '#ea51ff'], ['#FF9966', '#FF5E62'], ['#56CCF2', '#2F80ED'], ['#ffa9c6', '#f434e2']];
  var DEGRADE_ZOOM = ['#56CCF2', '#2F80ED'];
  var DEGRADE_PARTAGE = ['#80FF72', '#7EE8FA'];

  function bulle(texte) {
    var t = document.createElement('div');
    t.className = 'amavya-toast';
    t.setAttribute('role', 'status');
    t.textContent = texte;
    document.body.appendChild(t);
    window.requestAnimationFrame(function () { t.classList.add('is-in'); });
    window.setTimeout(function () {
      t.classList.remove('is-in');
      window.setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 450);
    }, 1900);
  }

  function copierLien(url) {
    if (!navigator.clipboard) { bulle(url); return; }
    navigator.clipboard.writeText(url).then(
      function () { bulle('Lien copié'); },
      function () { bulle(url); }
    );
  }

  function partager() {
    var url = window.location.href.split('#')[0];
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(function (erreur) {
        /* Une fenetre de partage fermee par la personne n'est pas une panne ; toute autre erreur retombe sur la copie. */
        if (!erreur || erreur.name !== 'AbortError') copierLien(url);
      });
      return;
    }
    copierLien(url);
  }

  /* Le nom de chaque photo vient de son texte alternatif : la maquette d'abord, puis la photo portee.
     Quand la galerie montre aussi le dos (choix de Tarek du 15/09/2026) : Produit face, Porte face, Produit dos, Porte dos. */
  function altDe(img) {
    return ((img && img.getAttribute('alt')) || '').toLowerCase();
  }

  function estDos(alt) {
    return /(^|[^a-z])dos([^a-z]|$)/.test(alt);
  }

  /* Cahiers de coloriage : couverture, dos, planches, et la photo de mise en situation. */
  function estLivre(alt) {
    return alt.indexOf('cahier') !== -1 || alt.indexOf('livre') !== -1 || alt.indexOf('planche') !== -1 || alt.indexOf('couverture') !== -1;
  }

  function nomDeLivre(img, i) {
    var alt = altDe(img);
    if (estDos(alt)) return ['Dos', 'dos'];
    var planche = alt.match(/planche\s*(\d+)/);
    if (planche) return ['Planche ' + planche[1], 'photo'];
    if (alt.indexOf('couverture') !== -1) return ['Couverture', 'livre'];
    if (alt.indexOf('colorie') !== -1 || alt.indexOf('photo réalisée') !== -1) return ['En situation', 'porte'];
    return i === 0 ? ['Couverture', 'livre'] : ['Photo ' + (i + 1), 'photo'];
  }

  function nomDe(img, i, avecDos) {
    var alt = altDe(img);
    if (avecDos) {
      var portee = alt.indexOf('porté') !== -1 || alt.indexOf('photo réalisée') !== -1;
      if (estDos(alt)) return portee ? ['Porté dos', 'porte'] : ['Produit dos', 'dos'];
      return portee ? ['Porté face', 'porte'] : ['Produit face', 'produit'];
    }
    if (estDos(alt)) return ['Dos', 'dos'];
    if (alt.indexOf('porté') !== -1) return ['Porté', 'porte'];
    if (i === 0) return ['Produit', 'produit'];
    return ['Photo ' + (i + 1), 'photo'];
  }

  function pastille(liste, titre, icone, degrade, action, estPhoto) {
    var li = document.createElement('li');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'amavya-gm__item';
    b.style.setProperty('--gm-from', degrade[0]);
    b.style.setProperty('--gm-to', degrade[1]);
    b.setAttribute('aria-label', estPhoto ? 'Afficher la photo : ' + titre : titre);
    if (estPhoto) b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<span class="amavya-gm__fond"></span><span class="amavya-gm__halo"></span>' +
      '<span class="amavya-gm__icone" aria-hidden="true"><svg viewBox="0 0 512 512" focusable="false">' + icone + '</svg></span>' +
      '<span class="amavya-gm__titre" aria-hidden="true">' + titre + '</span>';
    b.addEventListener('click', action);
    li.appendChild(b);
    liste.appendChild(li);
    return b;
  }

  function construire(galerie) {
    if (galerie.__amavyaGm) return;
    var grille = galerie.querySelector('.media-gallery__grid');
    var items = grille ? Array.prototype.slice.call(grille.querySelectorAll(':scope > li')) : [];
    var diapos = Array.prototype.slice.call(galerie.querySelectorAll('slideshow-slide'));
    var n = Math.max(items.length, diapos.length);
    if (n < 2) return;
    galerie.__amavyaGm = true;

    var liste = document.createElement('ul');
    liste.className = 'amavya-gm';
    liste.setAttribute('aria-label', 'Photos de l’article');

    var boutons = [];
    var actif = 0;

    function grilleVisible() {
      return !!grille && window.getComputedStyle(grille).display !== 'none';
    }

    function marquer(k) {
      for (var j = 0; j < boutons.length; j++) boutons[j].setAttribute('aria-pressed', j === k ? 'true' : 'false');
    }

    function afficher(k) {
      actif = k;
      marquer(k);
      if (grilleVisible()) {
        galerie.classList.add('amavya-scene');
        for (var j = 0; j < items.length; j++) items[j].classList.toggle('is-active', j === k);
        return;
      }
      var diaporama = galerie.slideshow || galerie.querySelector('slideshow-component');
      if (diaporama && typeof diaporama.select === 'function') diaporama.select(k);
    }

    var images = [];
    for (var s = 0; s < n; s++) {
      var origine = items[s] || diapos[s];
      images.push(origine ? origine.querySelector('img') : null);
    }
    var avecDos = images.some(function (img) { return estDos(altDe(img)); });
    var galerieLivre = images.some(function (img) { return estLivre(altDe(img)); });

    for (var i = 0; i < n; i++) {
      var nom = galerieLivre ? nomDeLivre(images[i], i) : nomDe(images[i], i, avecDos);
      boutons.push(pastille(liste, nom[0], ICONES[nom[1]], DEGRADES[i % DEGRADES.length], (function (k) {
        return function () { afficher(k); };
      })(i), true));
    }

    pastille(liste, 'Zoom', ICONES.zoom, DEGRADE_ZOOM, function (e) {
      if (typeof galerie.zoom === 'function') galerie.zoom(actif, e);
    }, false);
    pastille(liste, 'Partager', ICONES.partager, DEGRADE_PARTAGE, partager, false);

    liste.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      var k = (actif + (e.key === 'ArrowRight' ? 1 : -1) + n) % n;
      afficher(k);
      boutons[k].focus();
    });

    /* Sur ecran tactile en mise en page large : un glissement change aussi de photo. */
    if (grille) {
      var depart = null;
      grille.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') depart = e.clientX; }, { passive: true });
      grille.addEventListener('pointerup', function (e) {
        if (depart === null) return;
        var ecart = e.clientX - depart;
        depart = null;
        if (Math.abs(ecart) > 50 && galerie.classList.contains('amavya-scene')) afficher((actif + (ecart < 0 ? 1 : -1) + n) % n);
      }, { passive: true });
    }

    /* Sur telephone, Horizon garde son diaporama : quand on le fait glisser, la pastille suit. */
    var defilant = galerie.querySelector('slideshow-slides');
    if (defilant) {
      var attente = false;
      defilant.addEventListener('scroll', function () {
        if (attente || grilleVisible()) return;
        attente = true;
        window.requestAnimationFrame(function () {
          attente = false;
          if (!defilant.clientWidth) return;
          var k = Math.max(0, Math.min(n - 1, Math.round(Math.abs(defilant.scrollLeft) / defilant.clientWidth)));
          if (k !== actif) { actif = k; marquer(k); }
        });
      }, { passive: true });
    }

    galerie.appendChild(liste);
    if (grilleVisible()) afficher(0); else marquer(0);

    var largeur = window.matchMedia('(min-width: 750px)');
    var basculer = function () { if (galerie.isConnected) afficher(actif); };
    if (largeur.addEventListener) largeur.addEventListener('change', basculer); else if (largeur.addListener) largeur.addListener(basculer);
  }

  /* 3. Cartes produit en cascade. Une carte deja a l'ecran au chargement n'est jamais cachee. */
  var obsCartes = (!reduit && 'IntersectionObserver' in window) ? new IntersectionObserver(function (entrees) {
    var rang = 0;
    for (var i = 0; i < entrees.length; i++) {
      if (!entrees[i].isIntersecting) continue;
      entrees[i].target.style.setProperty('--amavya-delai', Math.min(rang, 8) * 70 + 'ms');
      entrees[i].target.classList.add('is-in');
      obsCartes.unobserve(entrees[i].target);
      rang++;
    }
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function marquerCartes(racine) {
    if (!obsCartes || !racine.querySelectorAll) return;
    var cartes = Array.prototype.slice.call(racine.querySelectorAll('product-card'));
    if (racine.matches && racine.matches('product-card')) cartes.push(racine);
    for (var i = 0; i < cartes.length; i++) {
      var cible = cartes[i].closest('li') || cartes[i];
      if (cible.__amavyaCarte) continue;
      cible.__amavyaCarte = true;
      if (cible.getBoundingClientRect().top < window.innerHeight * 0.92) continue;
      cible.classList.add('amavya-carte');
      obsCartes.observe(cible);
    }
  }

  /* Filet de securite : une carte que l'observateur aurait manquee reapparait d'elle-meme. */
  window.setInterval(function () {
    var restantes = document.querySelectorAll('.amavya-carte:not(.is-in)');
    for (var i = 0; i < restantes.length; i++) {
      if (restantes[i].getBoundingClientRect().top < window.innerHeight) restantes[i].classList.add('is-in');
    }
  }, 2500);

  /* 6. « t-shirt » insecable dans les titres et les cartes. */
  var ZONES_TITRES = 'h1, h2, h3, h4, product-card';

  function envelopper(noeud) {
    var morceaux = noeud.nodeValue.split(/(t-shirt)/i);
    if (morceaux.length < 2 || !noeud.parentNode) return;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < morceaux.length; i++) {
      if (!morceaux[i]) continue;
      if (/^t-shirt$/i.test(morceaux[i])) {
        var s = document.createElement('span');
        s.className = 'amavya-insecable';
        s.textContent = morceaux[i];
        frag.appendChild(s);
      } else {
        frag.appendChild(document.createTextNode(morceaux[i]));
      }
    }
    noeud.parentNode.replaceChild(frag, noeud);
  }

  function insecable(racine) {
    if (!racine.querySelectorAll) return;
    var zones = Array.prototype.slice.call(racine.querySelectorAll(ZONES_TITRES));
    if (racine.matches && racine.matches(ZONES_TITRES)) zones.push(racine);
    for (var i = 0; i < zones.length; i++) {
      var marcheur = document.createTreeWalker(zones[i], NodeFilter.SHOW_TEXT, null);
      var aTraiter = [];
      var noeud;
      while ((noeud = marcheur.nextNode())) {
        var parent = noeud.parentNode;
        if (!parent || /^(SCRIPT|STYLE|TEMPLATE|TEXTAREA)$/.test(parent.nodeName)) continue;
        if (parent.classList && parent.classList.contains('amavya-insecable')) continue;
        if (/t-shirt/i.test(noeud.nodeValue)) aTraiter.push(noeud);
      }
      for (var j = 0; j < aTraiter.length; j++) envelopper(aTraiter[j]);
    }
  }

  function brancher(racine) {
    if (!racine || !racine.querySelectorAll) return;
    var galeries = Array.prototype.slice.call(racine.querySelectorAll('media-gallery'));
    if (racine.matches && racine.matches('media-gallery')) galeries.push(racine);
    for (var i = 0; i < galeries.length; i++) construire(galeries[i]);
    marquerCartes(racine);
    insecable(racine);
  }

  /* Horizon remplace la galerie a chaque changement de variante et recharge des cartes au filtrage :
     tout ce qui arrive dans la page est rebranche, par lots, une fois par image. */
  var ajoutes = [];
  var lotPrevu = false;
  var IGNORES = /(^| )amavya-(insecable|onde|toast|gm)( |$)/;

  function surveiller() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var liste = mutations[i].addedNodes;
        for (var j = 0; j < liste.length; j++) {
          var el = liste[j];
          if (el.nodeType === 1 && !IGNORES.test(el.className || '')) ajoutes.push(el);
        }
      }
      if (!ajoutes.length || lotPrevu) return;
      lotPrevu = true;
      window.requestAnimationFrame(function () {
        lotPrevu = false;
        var lot = ajoutes;
        ajoutes = [];
        for (var k = 0; k < lot.length; k++) if (lot[k].isConnected) brancher(lot[k]);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* 2. Navigation instantanee : la page visee est deja telechargee quand on clique. */
  function precharger() {
    if (!window.HTMLScriptElement || !HTMLScriptElement.supports || !HTMLScriptElement.supports('speculationrules')) return;
    if (document.querySelector('script[data-amavya-speculation]')) return;
    var regles = document.createElement('script');
    regles.type = 'speculationrules';
    regles.setAttribute('data-amavya-speculation', '1');
    regles.textContent = JSON.stringify({
      prefetch: [{
        source: 'document',
        where: { and: [
          { href_matches: '/*' },
          { not: { href_matches: ['/cart', '/cart/*', '/checkout', '/checkouts/*', '/account', '/account/*', '/search', '/*logout*', '/challenge', '/password'] } },
          { not: { selector_matches: '[rel~="nofollow"], [target="_blank"], [download]' } }
        ] },
        eagerness: 'moderate'
      }]
    });
    document.head.appendChild(regles);
  }

  /* 3 bis. Inclinaison des cartes sous le pointeur. */
  function incliner() {
    if (!pointeurFin || reduit) return;
    var penchee = null;
    var redresser = function () {
      if (!penchee) return;
      penchee.style.removeProperty('--amavya-rx');
      penchee.style.removeProperty('--amavya-ry');
      penchee = null;
    };
    document.addEventListener('pointermove', function (e) {
      var g = e.target && e.target.closest ? e.target.closest('product-card .card-gallery') : null;
      if (penchee && penchee !== g) redresser();
      if (!g) return;
      var b = g.getBoundingClientRect();
      if (!b.width || !b.height) return;
      var px = (e.clientX - b.left) / b.width - 0.5;
      var py = (e.clientY - b.top) / b.height - 0.5;
      g.style.setProperty('--amavya-rx', (-py * 7).toFixed(2) + 'deg');
      g.style.setProperty('--amavya-ry', (px * 9).toFixed(2) + 'deg');
      penchee = g;
    }, { passive: true });
    document.documentElement.addEventListener('mouseleave', redresser);
  }

  /* 4. Retour en haut et ombre de l'en-tete. Horizon peut faire defiler .page-wrapper au lieu de la fenetre. */
  function defileur() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight > w.clientHeight + 1) return w;
    return null;
  }

  function retourEnHaut() {
    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'amavya-haut';
    bouton.setAttribute('aria-label', 'Revenir en haut de la page');
    bouton.innerHTML = '<svg class="amavya-haut__anneau" viewBox="0 0 48 48" aria-hidden="true" focusable="false"><circle cx="24" cy="24" r="22"/></svg>' +
      '<svg class="amavya-haut__fleche" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 19V5M5 12l7-7 7 7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    document.body.appendChild(bouton);

    var attente = false;
    var maj = function () {
      attente = false;
      var d = defileur();
      var y = d ? d.scrollTop : window.scrollY;
      var course = d ? d.scrollHeight - d.clientHeight : document.documentElement.scrollHeight - window.innerHeight;
      bouton.style.setProperty('--amavya-p', (course > 0 ? Math.min(1, y / course) : 0).toFixed(3));
      bouton.classList.toggle('is-visible', y > 600);
      var entete = document.getElementById('header-group');
      if (entete) entete.classList.toggle('amavya-defile', y > 8);
    };
    document.addEventListener('scroll', function () {
      if (attente) return;
      attente = true;
      window.requestAnimationFrame(maj);
    }, { capture: true, passive: true });
    bouton.addEventListener('click', function () {
      var d = defileur();
      (d || window).scrollTo({ top: 0, behavior: reduit ? 'auto' : 'smooth' });
    });
    maj();
  }

  /* 5. L'onde au clic : partie du point touche, jamais sur les pastilles du menu a degrade. */
  function ondes() {
    if (reduit) return;
    document.addEventListener('pointerdown', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.button:not(.button-unstyled)') : null;
      if (!b || b.closest('.amavya-gm')) return;
      var r = b.getBoundingClientRect();
      var cote = Math.max(r.width, r.height);
      var onde = document.createElement('span');
      onde.className = 'amavya-onde';
      onde.setAttribute('aria-hidden', 'true');
      onde.style.width = cote + 'px';
      onde.style.height = cote + 'px';
      onde.style.left = (e.clientX - r.left - cote / 2) + 'px';
      onde.style.top = (e.clientY - r.top - cote / 2) + 'px';
      if (window.getComputedStyle(b).position === 'static') b.classList.add('amavya-onde-hote-rel');
      b.classList.add('amavya-onde-hote');
      b.appendChild(onde);
      window.setTimeout(function () {
        if (onde.parentNode) onde.parentNode.removeChild(onde);
        if (!b.querySelector('.amavya-onde')) b.classList.remove('amavya-onde-hote', 'amavya-onde-hote-rel');
      }, 700);
    }, { passive: true });
  }

  function demarrer() {
    precharger();
    brancher(document.documentElement);
    surveiller();
    incliner();
    retourEnHaut();
    ondes();
    document.addEventListener('shopify:section:load', function (e) { brancher(e.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();